import { useTranslation } from 'react-i18next';

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '~/components/ui/select';
import type { ProductSearchField } from '~/features/explorer/types/products-catalog.types';
import { cn } from '~/utils/cn';

interface SearchFieldSelectProps {
  fields: ProductSearchField[];
  value: string;
  onChange: (key: string) => void;
  disabled?: boolean;
}

/** Field picker beside the catalog search box — chooses which identifier
 *  (offer id, item group id, MPN, GTIN, title) the typed term is matched against. */
export function SearchFieldSelect({
  fields,
  value,
  onChange,
  disabled = false,
}: SearchFieldSelectProps) {
  const { t } = useTranslation('explorer');

  return (
    <Select value={value} onValueChange={onChange} disabled={disabled}>
      <SelectTrigger
        aria-label={t('products.searchFieldLabel')}
        className={cn('h-10 w-[160px] shrink-0', disabled && 'cursor-not-allowed')}
      >
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {fields.map((f) => (
          <SelectItem key={f.key} value={f.key} className="cursor-pointer">
            {f.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
